import { graphql } from "relay-runtime"

export const chEditEpisodeOfCareMutation = graphql`
  mutation chEditEpisodeOfCareMutation($input: Ch_updateEpisodeOfCareInput!) {
    updateEpisodeOfCare: ch_updateEpisodeOfCare(input: $input) {
      episodeOfCare: ch_EpisodeOfCare {
        id
        ...chEpisodeOfCareFragment
      }
    }
  }
`
